/**
 * Cross-app auth handoff from the learner portal.
 *
 * No header or footer components: the page is a redirect, on screen for one
 * round trip, and chrome would only flash before the forward. No meta.auth
 * either — a learner reaching it is by definition not signed in here yet.
 */
export default [
    {
        path: '/proxy/auth',
        name: 'proxy.auth',
        components: {
            default: () => import('../views/public/proxyAuth/index.vue')
        }
    }
];
